module.exports = __webpack_public_path__ + "static/media/costQuestion.498d675f.mp3";